import React, { useMemo } from 'react';
import { Link, Routes, Route } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import equal from 'fast-deep-equal';
import FilesGroup from '../FilesGroup/FilesGroup';
import SearchProfile from '../SearchProfile/SearchProfile';
import Loading from '../Loading/Loading';
import { locale } from '../../api/config';
const { Header, Content, Sider } = Layout;

const LayoutCenter = ({
  flag,
  onChangeFlag,
  keyword,
  selectedIndustry,
  onChangeSelectedIndustry,
  industries,
  typeSeries,
  onChangeTypeSeries,
  selectedSeries,
  onchangeSelectedSeries,
  openType,
  onchangeOpenType,
  loading,
  onChangeLoading,
  handleRouter,
}) => {
  const menuIndustries = useMemo(() => {
    return industries.length > 0
      ? industries.map(industry => ({
          key: industry.id,
          label: (
            <Link to={`/${industry.id}`}>
              <strong>{industry.name[locale].toUpperCase()}</strong>
            </Link>
          ),
        }))
      : [];
  }, [industries]);
  const menuTypeSeries = useMemo(() => {
    return typeSeries.length > 0
      ? typeSeries.map(type => {
          if (type.name) {
            return {
              key: type.id,
              label: type.name,
              children:
                type.product_series.length > 0
                  ? type.product_series.map(series => ({
                      key: series.id,
                      label: (
                        <Link to={`${type.id}/${series.id}`}>
                          {series.name}
                        </Link>
                      ),
                    }))
                  : [],
            };
          }
        })
      : [];
  }, [typeSeries]);
  const openKeys = useMemo(() => {
    if (openType) {
      return [openType];
    } else {
      return typeSeries.length > 0 && [typeSeries[0].id];
    }
  }, [openType, typeSeries]);
  const selectedSeriesKeys = useMemo(() => {
    if (selectedSeries) {
      return [selectedSeries];
    } else {
      return (
        typeSeries.length > 0 &&
        typeSeries[0].product_series.length > 0 && [
          typeSeries[0].product_series[0].id,
        ]
      );
    }
  }, [selectedSeries, typeSeries]);
  const data = useMemo(() => {
    if (!selectedSeries) {
      return typeSeries.length > 0 && typeSeries[0].product_series.length > 0
        ? typeSeries[0].product_series[0]
        : {};
    } else if (openType && typeSeries.length > 0) {
      const typeData = typeSeries.find(type => type.id === openType) || {};
      const seriesData =
        Object.keys(typeData).length > 0 &&
        typeData.product_series.find(series => series.id === selectedSeries);
      return seriesData;
    }
  }, [selectedSeries, typeSeries]);
  let timeoutId = null;

  const handleSelect = key => {
    // 清除之前的计时器
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }

    // 设置一个新的计时器，延迟处理事件
    timeoutId = setTimeout(() => {
      onChangeSelectedIndustry(key);
      onChangeLoading(true);
      onChangeTypeSeries([]);
      onchangeOpenType(null);
      onchangeSelectedSeries(null);
      //  搜索结果隐藏
      onChangeFlag(false);
    }, 300); // 设置延迟时间，单位为毫秒，可以根据需要调整
  };
  return (
    <Layout>
      <Header
        style={{
          padding: 0,
          background: '#fff',
          width: '84.25%',
          position: 'absolute',
          transform: 'translate(10%,-50%)',
          margin: 'auto',
        }}
      >
        <Menu
          theme='light'
          mode='horizontal'
          selectedKeys={[selectedIndustry]}
          items={menuIndustries}
          onSelect={({ key }) => {
            handleSelect(key);
          }}
          style={{
            flex: 1,
            justifyContent: 'center',
            fontSize: 16,
            fontWeight: 500,
          }}
        />
      </Header>
      {loading ? (
        <Loading />
      ) : !flag ? (
        <Routes>
          {industries.map(industry => (
            <Route
              path={industry.id}
              element={
                <LevelRouterContainer
                  selectedSeriesKeys={selectedSeriesKeys}
                  openKeys={openKeys}
                  menuTypeSeries={menuTypeSeries}
                  onchangeSelectedSeries={onchangeSelectedSeries}
                  onchangeOpenType={onchangeOpenType}
                  typeSeries={typeSeries}
                  data={data}
                />
              }
            >
              {typeSeries.length > 0 && handleRouter()}
            </Route>
          ))}
        </Routes>
      ) : (
        <Layout>
          <Content
            style={{
              padding: 24,
              margin: 0,
              minHeight: 280,
            }}
          >
            <SearchProfile keyword={keyword} />
          </Content>
        </Layout>
      )}
    </Layout>
  );
};

function LevelRouterContainer({
  selectedSeriesKeys,
  openKeys,
  menuTypeSeries,
  onchangeSelectedSeries,
  onchangeOpenType,
  typeSeries,
  data,
}) {
  // TODO 提取优化这个函数
  const handleRouterTwo = () => {
    let routes = [];
    if (typeSeries.length > 0) {
      typeSeries.forEach(type => {
        let innerArr = type.product_series.map(series => {
          return (
            <Route
              path={`${type.id}/${series.id}`}
              element={<LevelRouterContent data={data} />}
            />
          );
        });
        routes = routes.concat(innerArr);
      });
    }
    return routes;
  };
  return (
    <Layout
      style={{
        paddingLeft: '8.25%',
      }}
    >
      <Sider
        width={'16.667vw'}
        style={{
          background: '#F9F9F9',
          borderLeft: '1px solid #ECECEC',
          borderRight: '1px solid #ECECEC',
        }}
      >
        <Menu
          mode='inline'
          selectedKeys={selectedSeriesKeys}
          openKeys={openKeys}
          onOpenChange={openKeys => {
            onchangeOpenType(openKeys[1]);
          }}
          onClick={({ keyPath }) => {
            onchangeOpenType(keyPath[1]);
            onchangeSelectedSeries(keyPath[0]);
          }}
          style={{
            height: '100%',
            borderRight: 0,
            background: '#F9F9F9',
          }}
          items={menuTypeSeries}
        />
      </Sider>
      {<Routes>{typeSeries.length > 0 && handleRouterTwo()}</Routes>}
    </Layout>
  );
}

function LevelRouterContent({ data = {} }) {
  return (
    <Layout>
      <Content
        style={{
          padding: 24,
          margin: 0,
          minHeight: 280,
        }}
      >
        {Object.keys(data).length > 0 && <FilesGroup data={data} />}
      </Content>
    </Layout>
  );
}
export default React.memo(LayoutCenter, equal);
